module.exports = __webpack_public_path__ + "img/nt-bottom.5a2bc3fc.png";